import React from 'react';
import PropTypes from 'prop-types';
import { Input } from './style';
export var RadioButton = function RadioButton(props) {
  return React.createElement(Input, {
    id: props.id,
    type: "radio",
    name: props.name,
    value: props.value,
    disabled: props.disabled,
    onChange: props.onChange,
    checked: props.checked
  });
};
RadioButton.propTypes = {
  id: PropTypes.string,
  disabled: PropTypes.bool.isRequired,
  name: PropTypes.string,
  value: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};